$(document).on("ready", function () {
  $(".opportunity-card__message").on("click", function () {
    var url = $(this).data("log-url");
    $.ajax({
      url: url,
      type: "GET",
    });
  });
});
